import React, { useMemo, forwardRef } from 'react'
import { getTokenValue, Token, Spinner as TSpinner } from 'tamagui'

export const Spinner = forwardRef<
  typeof TSpinner,
  { color: Token; size: Token }
>(({ color, size, ...props }, ref) => {
  const parsedColor = useMemo(() => {
    return getTokenValue(color, 'color')
  }, [color])

  const parsedSize = useMemo(() => {
    return getTokenValue(size, 'size')
  }, [size])

  return (
    <TSpinner
      ref={ref}
      {...props}
      size={parsedSize}
      color={parsedColor}
      aria-label='Loading...'
    />
  )
})
